import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { FcuStatus, FcuStatusObject, FuStatus } from '@models/system-status';
import { SystemStatusRoutingService } from '@service/system-status-routing.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-fcu-status',
    templateUrl: './fcu-status.component.html',
    styleUrls: ['./fcu-status.component.scss'],
    standalone: false
})
export class FcuStatusComponent implements OnInit, OnDestroy, OnChanges {
    @Input() isReceivingData: boolean;
    @Input() fcuStatusObject: FcuStatusObject;
    @Input() selectedFcu: FcuStatus;
    @Input() selectedFcuSrc: string;
    @Output() onShowFcuList: EventEmitter<void> = new EventEmitter<void>();

    selectedFu: FuStatus;

    constructor(private systemStatusRoutingService: SystemStatusRoutingService) {}

    selectedFuSubscription: Subscription;
    selectedFcuSubscription: Subscription;

    ngOnInit(): void {
        this.selectedFuSubscription = this.systemStatusRoutingService
            .selectedFuIndexSubject()
            .subscribe(({ fcuSrc, fuIndex }) => {
                this.selectedFcu = this.fcuStatusObject[fcuSrc];
                this.selectedFu = this.selectedFcu.fu[fuIndex];
                this.selectedFcuSrc = fcuSrc;
            });

        this.selectedFcuSubscription = this.systemStatusRoutingService
            .selectedFcuIndexSubject()
            .subscribe((fcuSrc) => {
                this.selectedFcu = this.fcuStatusObject[fcuSrc];
                this.selectedFcuSrc = fcuSrc;
                this.selectedFu = null;
            });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.fcuStatusObject && this.selectedFcuSrc) {
            this.selectedFcu = this.fcuStatusObject[this.selectedFcuSrc];
        }
    }

    ngOnDestroy(): void {
        this.selectedFuSubscription?.unsubscribe();
        this.selectedFcuSubscription?.unsubscribe();
    }

    handleSelectedFcu(fcu) {
        this.selectedFu = null;
        if (fcu) {
            this.selectedFcuSrc = fcu.key;
            this.selectedFcu = fcu.value;
        } else {
            this.selectedFcuSrc = null;
            this.selectedFcu = null;
            this.systemStatusRoutingService.openFcuListPage()
        }   
    }
}
